// extracted by css-extract-rspack-plugin
export default {"placeholderClass":"_fc198cc3"};